require([
  'jquery',
  'address-utils',
  'mojo-analytics',
  'utils',
  'parsleyjs',
], function (
  $,
  addressUtils,
  MojoAnalytics,
  utils
) {

  var $newSignupButton = $('#new-signup-button');
  var $existingSignupButton = $('#existing-signup-button');
  var $verisignSignupForm = $('#verisign-signup-form');
  var $verisignSigninForm = $('#verisign-signin-form');
  var $stateSelect = $('#state-list');

  // store domain name and campaign id from query params
  let $domainName = utils.getURLParameter('domain');
  let $campaignId = utils.getURLParameter('campaign');
  let $domainPrice = document.querySelector('.domain-price').textContent.substr(2);

  //This is to switch signup tab between New customer and existing customer signup
  $newSignupButton.click(function () {

    $newSignupButton.addClass('active');
    $existingSignupButton.removeClass('active');
    $verisignSigninForm.hide();
    $verisignSignupForm.show();
  });

  $existingSignupButton.click(function () {

    $existingSignupButton.addClass('active');
    $newSignupButton.removeClass('active');
    $verisignSigninForm.show();
    $verisignSignupForm.hide();
  });

  $verisignSignupForm.on('submit', function (e) {
    if (e.originalEvent) {
      e.preventDefault();
      if ($verisignSignupForm.parsley().isValid()) {
        $verisignSignupForm.submit();
      }
    }
  });

  $verisignSigninForm.on('submit', function (e) {
    if (e.originalEvent) {
      e.preventDefault();
      if ($verisignSigninForm.parsley().isValid()) {
        $verisignSigninForm.submit();
      }
    }
  });

  MojoAnalytics.sendEvent({
    eventName: 'Viewed Landing Page',
    eventData: {
      page_name: 'purchase-domain',
      domain_name: $domainName,
      domain_price: $domainPrice,
    },
  });

  function dumpQueryParamsInForms () {
    $('#domain-signup').attr('value', $domainName);
    $('#campaign-signup').attr('value', $campaignId);

    $('#domain-signin').attr('value', $domainName);
    $('#campaign-signin').attr('value', $campaignId);
  }

  function setFormsPostUrlWithQueryParams () {
    let registerUrl = `/accounts/domains/register?domain=${$domainName}&campaign=${$campaignId}`;
    let loginUrl = `/accounts/domains/login?domain=${$domainName}&campaign=${$campaignId}`;

    $verisignSignupForm.attr('action', registerUrl);
    $verisignSigninForm.attr('action', loginUrl);
  }

  function addPrefixToPhoneField () {
    $('#phone-number').keydown(function () {
      var oldvalue = $(this).val();
      var field = this;
      setTimeout(function () {
        if (field.value.indexOf('+91') !== 0) {
          $(field).val(oldvalue);
        }
      }, 1);
    });
  }

  $(window).on('load', function () {
    addressUtils.insertStateList($stateSelect);
    dumpQueryParamsInForms();
    setFormsPostUrlWithQueryParams();
    addPrefixToPhoneField();
  });

});

define("verisign-signup-signin", function(){});

